<template>
    <!-- (기존 UI 그대로) -->
    <div class="ld-container" style="height: 90vh; width: 100%">
        <div class="row" style="height: 100%">
            <div class="list-area col-md-6">
                <div class="row">
                    <header-box :title="`${$t('운영 기준정보 관리')} > ${$t('알람 발생 이력')}`" />
                </div>

                <!-- 검색·기간 -->
                <div class="search-option-container">
                    <div class="search-items-row">
                        <div class="search-item search-item-period">
                            <div class="search-label">{{ $t("기간") }}</div>
                            <b-form-select
                                v-model="selectedPeriod"
                                :options="periodSelectOptions"
                                class="period-select"
                            />
                        </div>
                        <div class="search-item search-item-date">
                            <div class="search-label">{{ $t("날짜 선택") }}</div>
                            <date-picker
                                v-model="dateRange"
                                range
                                format="YYYY-MM-DD"
                                value-type="format"
                                :placeholder="$t('날짜를 선택하세요')"
                                :clearable="true"
                                :editable="false"
                                :disabled="selectedPeriod !== 'manual'"
                                class="date-picker-input"
                                @change="onDateRangeChange"
                            />
                        </div>
                        <!-- <div class="search-item search-item-alarm">
                            <div class="search-label">{{ $t("일련번호") }}</div>
                            <valid-input
                                input-type="text"
                                :input-value.sync="searchAlarmLogIdx"
                                :placeholder="$t('알람 일련번호로 검색')"
                                :NonStatus="true"
                                :rules="rules.ALARM_LOG_IDX"
                                @keydownMethod="onclickSearch"
                            />
                        </div> -->
                        <div class="search-item search-button-item">
                            <button
                                class="btn btn-primary button-shadow searchButton"
                                @click="onclickSearch"
                                type="button"
                            >
                                {{ $t("조회") }}
                            </button>
                        </div>
                    </div>
                </div>

                <!-- 목록 -->
                <div style="height: calc(100% - 70px)" class="alarm-event-list-table">
                    <TableList
                        ref="tableList"
                        :title="'알람 목록'"
                        :columns="columns"
                        :rows="alarmList"
                        :keyField="'alarmIdx'"
                        :transCodes="transCodes"
                        headerMargin="0px"
                        :controls="controls"
                        :useMaxHeight="true"
                        :mode="'edit'"
                        :isPageNation="true"
                        :useFilter="false"
                        perPageOpt="50"
                        :forAlaram="true"
                        :totNumber="alarmTot"
                        :showAllLabel="false"
                        @button-click="handleListButtonClick"
                        @row-click="onRowClick"
                        @on-per-page-change="onChangePerPage"
                        @on-page-change="onPageChange"
                    />
                </div>
            </div>

            <!-- 상세 -->
            <div class="detail-area col-md-6 alarm-event-detail-table">
                <AlarmDetail
                    ref="alarmDetail"
                    :title="'알람 이벤트 상세'"
                    :data="alarmDetail"
                    :selectedAlarmEventTot="selectedAlarmEventTot"
                    @refresh="refreshDetail"
                    @close="handleDetailClosed"
                    @on-per-page-change="onDetailPerPageChange"
                    @on-page-change="onDetailPageChange"
                />
            </div>
        </div>
        <div class="loading-overlay" v-if="loadingAlarm">
            <b-spinner :variant="'secondary'" :key="'secondary'"></b-spinner>
        </div>
    </div>
</template>

<script>
import HeaderBox from "@views/component/headerBox/analysis/Header.vue";
import TableList from "@views/component/v2.1/ListDetailView/TableList.vue";
import AlarmDetail from "./AlarmDetail.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import backEndApi from "@src/api/backEndApi";
import * as rules from "@src/consts/ruleConsts.js";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

/* ─── 상수 ──────────────────────── */
const PAGE_LIMIT = 50;
const PERIOD_OPTIONS = { ALL: "전체", 3: "3일", 7: "7일", 30: "1개월", 90: "3개월", manual: "직접 선택" };

export default {
    components: { HeaderBox, TableList, AlarmDetail, DatePicker },

    data() {
        return {
            /* rules 상수 그대로 노출 */
            rules,

            /* 검색/필터 */
            periodOptions: PERIOD_OPTIONS,
            selectedPeriod: "7", // 문자열 key 유지
            searchAlarmLogIdx: null,
            dateRange: [], // 날짜 범위 [시작일, 종료일]

            loadingAlarm: false,

            /* 목록 */
            alarmList: [],
            alarmTot: 0,
            alarmPerPage: PAGE_LIMIT,
            alarmCurrentPage: 1,
            alarmOffset: 0,
            /* 상세 */
            alarmDetail: null,
            selectedAlarmIdx: null,
            selectedAlarmEventTot: null,
            alarmEventPerPage: PAGE_LIMIT,
            alarmEventCurrentPage: 1,
            alarmEventOffset: 0,

            /* 목록 컬럼 및 버튼 */
            columns: [
                {
                    label: this.$t("최근 발생 일자"),
                    field: "modDateAlarm",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: this.$t("이벤트 유형"),
                    field: "eventSrcType",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: this.$t("이벤트 발생 대상"),
                    field: "eventObjName",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: this.$t("알람유형"),
                    field: "alarmType",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: this.$t("심각도"),
                    field: "severity",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: this.$t("상태"),
                    field: "status",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: this.$t("이벤트 수"),
                    field: "eventCount",
                    type: "text",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
            ],

            controls: [
                { event: "Active", label: "활성", class: "btn-primary" },
                { event: "Acked", label: "인지", class: "btn-info" },
                { event: "Resolved", label: "해결", class: "btn-success" },
                { event: "Dismissed", label: "무시", class: "btn-secondary" },
            ],
        };
    },

    computed: {
        ...mapGetters({ storeSelectedAlarmLogIdx: "getAlarmLogIdx", commonCodes: "commonCodes" }),
        periodQuery() {
            return this.selectedPeriod === "manual" ? null : this.selectedPeriod;
        },
        periodSelectOptions() {
            return Object.entries(this.periodOptions).map(([value, text]) => ({
                value: value,
                text: text,
            }));
        },
        transCodes() {
            return [
                { field: "alarmType", codes: this.commonCodes.alarmType },
                { field: "severity", codes: this.commonCodes.alarmSeverity },
                { field: "status", codes: this.commonCodes.alarmStatus },
                { field: "eventSrcType", codes: this.commonCodes.eventType },
            ];
        },
    },

    /* ---------- 반응형 속성 감시 ---------- */
    watch: {
        selectedPeriod() {
            if (this.selectedPeriod !== "manual") {
                this.dateRange = null;
            }
        },
    },

    /* ---------- 최초 로드 ---------- */
    async mounted() {
        if (this.storeSelectedAlarmLogIdx) {
            this.selectedPeriod = "ALL";
            this.searchAlarmLogIdx = this.storeSelectedAlarmLogIdx;
            await this.onclickSearch();
            this.updateAlarmLogIdx(null);

            // 스토어에서 가져온 값으로 데이터 fetch 후 초기화
            this.updateLocalAlarmLogIdx(null);
        } else {
            await this.fetchAlarmList();
        }
    },

    methods: {
        /* Vuex */
        ...mapActions({
            updateAlarmBadge: "UPDATE_ALARM_BADGE",
            updateAlarmLogIdx: "UPDATE_ALARMLOGIDX",
        }),

        /* --- API 래퍼 --- */
        async requestAlarmList({
            status = null,
            days = null,
            limit = null,
            offset = null,
            alarmLogIdx = null,
            fromDate = null,
            toDate = null,
        }) {
            try {
                this.loadingAlarm = true;
                const { data, status: code } = await backEndApi.newAlarm.getAlarmList(
                    status,
                    days,
                    limit,
                    offset,
                    alarmLogIdx,
                    fromDate,
                    toDate
                );
                if (code === 200) return data;
                this.alertWarning(data.message);
            } catch (e) {
                console.error(e);
                this.alertWarning("알람 목록을 가져오는 중 오류가 발생했습니다.");
            } finally {
                this.loadingAlarm = false;
            }
        },
        async requestAlarmDetail(alarmIdx, status, { limit = PAGE_LIMIT, offset = 0, alarmLogIdx = null } = {}) {
            let days = this.periodQuery;
            let fromDate = null;
            let toDate = null;
            if (this.selectedPeriod === "manual") {
                days = null;
                fromDate = this.dateRange[0];
                toDate = this.dateRange[1];
            }
            try {
                const { data, status } = await backEndApi.newAlarm.getAlarmDetail(
                    alarmIdx,
                    status,
                    days,
                    limit,
                    offset,
                    alarmLogIdx,
                    fromDate,
                    toDate
                );
                if (status === 200) {
                    return data;
                }
                this.alertWarning(data.message);
            } catch (e) {
                console.error(e);
            }
        },

        /* --- 목록 / 상세 --- */
        async fetchAlarmList() {
            try {
                const queryParams = this.buildAlarmQueryParams();

                if (!queryParams) {
                    return; // 유효성 검사 실패 시 조기 반환
                }

                const response = await this.requestAlarmList(queryParams);

                if (!response) {
                    return;
                }

                this.updateAlarmListData(response);
            } catch (error) {
                console.error("알람 목록 조회 중 오류 발생:", error);
                this.alertWarning("알람 목록을 불러오는 중 오류가 발생했습니다.");
            }
        },

        /**
         * 알람 조회 쿼리 파라미터를 구성합니다
         * @returns {Object|null} 쿼리 파라미터 객체 또는 null (유효성 검사 실패 시)
         */
        buildAlarmQueryParams() {
            const baseParams = {
                limit: this.alarmPerPage,
                offset: this.alarmOffset,
                alarmLogIdx: this.searchAlarmLogIdx,
            };

            // 수동 날짜 선택 모드인 경우
            if (this.selectedPeriod === "manual") {
                if (!this.isValidDateRange()) {
                    this.alertNoti("날짜 범위를 선택해주세요.");
                    return null;
                }

                return {
                    ...baseParams,
                    fromDate: this.dateRange[0],
                    toDate: this.dateRange[1],
                    days: null,
                };
            }

            // 기간 선택 모드인 경우
            return {
                ...baseParams,
                days: this.periodQuery,
                fromDate: null,
                toDate: null,
            };
        },

        /**
         * 날짜 범위 유효성을 검사합니다
         * @returns {boolean} 유효한 날짜 범위인지 여부
         */
        isValidDateRange() {
            return (
                this.dateRange &&
                Array.isArray(this.dateRange) &&
                this.dateRange.length === 2 &&
                this.dateRange.every((date) => date && date.trim() !== "")
            );
        },

        /**
         * 알람 목록 데이터를 업데이트합니다
         * @param {Object} response - API 응답 데이터
         */
        updateAlarmListData(response) {
            this.alarmList = response.rows.map(this.formatAlarmRow);
            this.alarmTot = Number(response.count);
        },

        /**
         * 알람 행 데이터를 포맷팅합니다
         * @param {Object} row - 원본 알람 행 데이터
         * @returns {Object} 포맷팅된 알람 행 데이터
         */
        formatAlarmRow(row) {
            return {
                ...row,
                modDateAlarm: moment(row.modDate).format("YYYY-MM-DD HH:mm:ss"),
            };
        },
        async refreshDetail() {
            if (!this.selectedAlarmIdx) return;
            this.alarmDetail = await this.requestAlarmDetail(this.selectedAlarmIdx, null, {
                limit: this.alarmEventPerPage,
                offset: this.alarmEventOffset,
            });
        },

        /* --- 조회 버튼 / 엔터 --- */
        async onclickSearch() {
            this.alarmCurrentPage = 1;
            this.alarmOffset = 0;
            await this.fetchAlarmList();

            // selectedAlarmIdx가 있으면 해당 알람의 상세 정보를 자동으로 fetch
            if (this.selectedAlarmIdx) {
                await this.refreshSelectedAlarmDetail();
            } else {
                // selectedAlarmIdx가 없고 searchAlarmLogIdx가 있으면 첫 번째 알람의 상세 정보를 fetch
                const firstIdx = this.alarmList[0]?.alarmIdx;
                if (this.searchAlarmLogIdx && firstIdx) {
                    this.alarmDetail = await this.requestAlarmDetail(firstIdx, null, {
                        alarmLogIdx: this.searchAlarmLogIdx,
                    });
                }
            }
        },

        /* --- 상세 페이지 관련 --- */
        async refreshSelectedAlarmDetail() {
            // 상세 페이지의 offset과 currentPage 초기화
            this.alarmEventCurrentPage = 1;
            this.alarmEventOffset = 0;

            this.alarmDetail = await this.requestAlarmDetail(this.selectedAlarmIdx, null, {
                limit: this.alarmEventPerPage,
                offset: this.alarmEventOffset,
            });
            this.findSelectedAlarmTot();

            // AlarmDetail의 TableList를 첫 페이지로 이동
            this.$nextTick(() => {
                if (this.$refs.alarmDetail && this.$refs.alarmDetail.$refs["table-list"]) {
                    this.$refs.alarmDetail.$refs["table-list"].goToFirstPage();
                }
            });
        },

        goToFirstPage() {
            this.refreshSelectedAlarmDetail();
        },

        /* --- 날짜 범위 처리 --- */
        onDateRangeChange(dateRange) {
            if (dateRange && dateRange.length === 2) {
                // 날짜 범위가 선택되면 기간 선택을 "manual"로 변경
                this.selectedPeriod = "manual";
            }
        },

        /* --- 테이블 핸들러 --- */
        onPageChange(page) {
            this.alarmCurrentPage = page;
            this.alarmOffset = (page - 1) * this.alarmPerPage;
            this.fetchAlarmList();
        },
        onChangePerPage(limit) {
            this.alarmPerPage = limit;
            this.onclickSearch();
        },
        onRowClick(row) {
            this.selectedAlarmIdx = row.alarmIdx;
            this.refreshSelectedAlarmDetail();
        },

        /* --- 상세 페이징 --- */
        onDetailPageChange(page) {
            this.alarmEventCurrentPage = page;
            this.alarmEventOffset = (page - 1) * this.alarmEventPerPage;
            this.refreshDetail();
        },
        onDetailPerPageChange(limit) {
            this.alarmEventPerPage = limit;
            this.refreshDetail();
        },

        /* --- 버튼으로 상태 변경 --- */
        async handleListButtonClick(event) {
            const checked = this.$refs.tableList.getCheckedRows();
            if (!checked.length) {
                this.alertNoti("상태 변경할 알람을 선택해주세요.");
                return;
            }

            const confirm = await this.alertConfirmWarning("알람 상태를 변경하시겠습니까?");
            if (!confirm.value) return;
            const findStatus = this.commonCodes.alarmStatus.find((item) => item.value == event);
            const statusName = findStatus ? findStatus.text : "";

            await Promise.all(
                checked.map(({ alarmIdx }) => backEndApi.newAlarm.updateAlarmStatus({ alarmIdx, status: event }))
            );

            this.updateAlarmBadge(true);
            await this.alertNoti(`${checked.length} 건의 알람 상태를 ${statusName}(으)로 변경하였습니다.`);
            this.onclickSearch();
            this.handleDetailClosed();
        },

        /* --- 기타 --- */
        handleDetailClosed() {
            this.alarmDetail = null;
        },
        findSelectedAlarmTot() {
            if (!this.selectedAlarmIdx) return;
            this.selectedAlarmEventTot = this.alarmList.find(
                (alarm) => alarm.alarmIdx === this.selectedAlarmIdx
            ).eventCount;
            return;
        },
        updateLocalAlarmLogIdx(value) {
            this.searchAlarmLogIdx = value;
        },
    },
};
</script>

<style scoped>
/* 검색 옵션 컨테이너 */
.search-option-container {
    width: 100%;
    /* margin-bottom: 10px; */
    /* background-color: #f1f1f1; */
    /* border: 1px solid #d1d5db; */
    /* border-radius: 6px; */
    padding: 8px 12px;
    /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */
}

/* 검색 아이템들 행 */
.search-items-row {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-end;
    width: 100%;
}

/* 각 검색 아이템 기본 스타일 */
.search-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    /* gap: 6px; */
}

/* 기간 아이템 - 15% */
.search-item-period {
    width: 19%;
}

/* 날짜 범위 아이템 - 30% */
.search-item-date {
    width: 35%;
}

/* 알람 일련번호 아이템 - 25% */
.search-item-alarm {
    width: 28%;
}

/* 조회 버튼 아이템 - 10% */
.search-button-item {
    width: 10%;
}

/* 라벨 스타일 */
.search-label {
    font-size: 12px;
    font-weight: 500;
    color: #2d353c;
    white-space: nowrap;
    background-color: #d5dbe0;
    padding: 7px 12px;
    border-radius: 6px 0 0 6px;
    border: 1px solid #d5dbe0;
}

/* 기간 select 스타일 */
.search-item-period .period-select {
    border-radius: 0 6px 6px 0;
    border-left: none;
}

.search-item .mx-input-wrapper .mx-input:focus {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
}

.search-item .mx-input-wrapper .mx-input:hover {
    border-color: #9ca3af !important;
}

/* 조회 버튼 */
.searchButton {
    width: 100%;
}

.ld-container {
    height: 90vh;
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    padding: 10px 30px 10px 20px;
}
.ld-container .list-area {
    height: 100%;
    overflow: hidden;
    padding: 10px;
}
.ld-container .detail-area {
    height: 100%;
    padding: 0 10px;
    background-color: #f9f9f9;
    border: 1px solid #e7e7e7;
    border-radius: 10px;
}
::v-deep .footer__row-count__label {
    margin-bottom: 0 !important;
}
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(240, 240, 240, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
</style>
